import { useMemo } from 'react';
import { Telemetry } from 'core/models/FMS/Telemetry';

const statusToName: Record<Telemetry.Status, string> = {
    initializing: '初期化中',
    task_acceptable: 'タスク待ち',
    ready: '発進指示待ち',
    driving: '走行中',
    suspending: '一時停止中',
    stopping: '停止中',
    abnormal: '異常発生中',
    connected: '接続中',
    disconnected: '未接続',
    shutdown: '電源OFF',
    pausing_for_stop_line: '一時停車(停止線)',
    pausing_for_obstacle: '一時停車(障害物)',
};

export function useTelemetryStatusName(status: Telemetry.Status | undefined) {
    return useMemo(() => {
        return status ? statusToName[status] : undefined;
    }, [status]);
}
